module.exports = __webpack_public_path__ + "src/app/assets/images/sug-torino.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/sug-torino.jpg
// module id = 624
// module chunks = 0